import MessageContent from './MessageContent';

export default MessageContent;
